import { useContext } from 'react';
import { HomePageSectionContext } from './HomePageSectionContext';

/**
 * A hook to retrieve home page section information.
 */
export const useHomePageSection = () => useContext(HomePageSectionContext);
